import { DATA_OPERATION } from 'store/enums';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  customerType: DATA_OPERATION.CUSTOMER_TYPE.PARTICULAR,
  flux: DATA_OPERATION.FLUX.BBVA,
  dealerCode: '',
  prospect: {
    contact: [
      {
        contactType: DATA_OPERATION.CONTACT_TYPE.CONTACT,
        documentType: '1',
        documentId: '',
        name: '',
        lastname: '',
        lastname2: '',
        genre: '',
        maritalStatus: null,
        jobType: null,
        riskEvalAdditionalData: {
          companyName: null,
          companyRegistrationDate: null,
          companyFunction: null,
          financialIncomes: null
        },
        address: {
          streetType: '',
          address1: '',
          postalCode: '',
          provinceCode: '',
          cityCode: ''
        },
        confirmEmail: '',
        confirmMobile: '',
        email: '',
        phone: '',
        mobile: '',
        chkRobinson: false,
        chkTermsAndConditions: false,
        chkDataTransfer: false,
        chkProactive: false,
        birthDate: '',
        driverLicenseIssuedDate: '',
        signType: ''
      }
    ]
  },
  signRequest: {
    bankAccount: '',
    delivery: {
      provinceCode: ''
    }
  },
  user: 'BBVA_CONNECT'
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
